import { chapters, timelineSegments, type TimelineSegment } from "@/data/chapters";

export type SegmentFilter = TimelineSegment | "全部";

interface FilterSidebarProps {
  segment: SegmentFilter;
  onSegmentChange: (value: SegmentFilter) => void;
  onlyFavorites: boolean;
  onToggleFavorites: () => void;
  favoriteCount: number;
}

const options: SegmentFilter[] = ["全部", ...timelineSegments];

export function segmentCount(segment: SegmentFilter) {
  return segment === "全部" ? chapters.length : chapters.filter((item) => item.segment === segment).length;
}

export default function FilterSidebar({
  segment,
  onSegmentChange,
  onlyFavorites,
  onToggleFavorites,
  favoriteCount,
}: FilterSidebarProps) {
  return (
    <aside className="hidden lg:block">
      <div className="surface-card sticky top-24 p-5">
        <div className="flex items-center gap-2">
          <i className="ri-git-commit-line text-sm leading-none text-accent-500" />
          <h2 className="font-heading text-sm text-foreground-950">剧情时间线</h2>
        </div>
        <div className="mt-4 flex flex-col gap-1">
          {options.map((item) => {
            const active = segment === item;
            return (
              <button
                key={item}
                type="button"
                onClick={() => onSegmentChange(item)}
                className={`group flex cursor-pointer items-center justify-between rounded-md px-3 py-2.5 text-left transition-colors ${
                  active ? "bg-primary-500/15 text-accent-400" : "text-foreground-700 hover:bg-background-200/60"
                }`}
              >
                <span className="flex items-center gap-2 font-label text-sm">
                  <span
                    className={`h-1.5 w-1.5 rounded-full ${active ? "bg-accent-500" : "bg-background-400"}`}
                  />
                  {item}
                </span>
                <span className="font-label text-[11px] text-foreground-500">{segmentCount(item)}</span>
              </button>
            );
          })}
        </div>

        <div className="my-5 h-px bg-background-200" />

        <div className="flex items-center gap-2">
          <i className="ri-bookmark-3-line text-sm leading-none text-accent-500" />
          <h2 className="font-heading text-sm text-foreground-950">我的收藏</h2>
        </div>
        <button
          type="button"
          onClick={onToggleFavorites}
          className={`mt-3 flex w-full cursor-pointer items-center justify-between rounded-md border px-3 py-2.5 font-label text-sm transition-colors ${
            onlyFavorites
              ? "border-accent-500/60 bg-accent-500/10 text-accent-400"
              : "border-background-300 text-foreground-700 hover:border-accent-500/50"
          }`}
        >
          <span className="flex items-center gap-2">
            <i className={`${onlyFavorites ? "ri-bookmark-3-fill" : "ri-bookmark-3-line"} text-base leading-none`} />
            只看已收藏
          </span>
          <span className="text-[11px]">{favoriteCount}</span>
        </button>
        <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
          收藏保存在本机浏览器中，无需登录，换设备或清理缓存后不会保留。
        </p>

        <div className="my-5 h-px bg-background-200" />

        <div className="rounded-md border border-background-200 bg-background-200/40 p-4">
          <p className="font-label text-[11px] tracking-[0.18em] text-accent-500">观看提示</p>
          <p className="mt-2 text-xs leading-relaxed text-foreground-600">
            播放区域为前端演示模块，暂未接入真实播放入口。站内剧情解说为原创整理内容。
          </p>
        </div>
      </div>
    </aside>
  );
}